/**
 * De onde veio cada linha da trilha de edição de classificação
 * (2026-10-18) — espelho de `core.vocabulary.CLASSIFICATION_EDIT_KINDS`,
 * com paridade travada por `tests/test_classification_edit_kind_parity.py`
 * (lê este arquivo, inclusive a SEQUÊNCIA, que é a ordem do `<select>`).
 * O mapa de rótulos é tipado sobre a tupla de propósito: chave a menos ou
 * a mais é erro de compilação, não uma opção sem nome na tela.
 */

export const CLASSIFICATION_EDIT_KINDS = ["manual", "bulk_edit", "ai_reprocess", "revert"] as const;

export type ClassificationEditKind = (typeof CLASSIFICATION_EDIT_KINDS)[number];

export const CLASSIFICATION_EDIT_KIND_LABELS: Record<ClassificationEditKind, string> = {
  manual: "Manual",
  bulk_edit: "Em lote",
  ai_reprocess: "Reprocessamento por IA",
  revert: "Volta de versão"
};
